import { all } from 'redux-saga/effects';
import attrCrud from './crud';

export default all([attrCrud]);
